import React from 'react'

const Form: React.FC<{ id: string }> = ({ id }) => (
  <div
    id={id}
    {...{ 'data-name': 'Unified' }}
    dangerouslySetInnerHTML={{
      __html: `
<form id="localAccountForm" action="JavaScript:void(0);" class="localAccount" aria-label="Sign in with your email address" data-bitwarden-watching="1">
  <div class="intro">
    <h2 aria-level="1">
      Sign in with your email address
    </h2>
  </div>
  <div class="error pageLevel" aria-hidden="true" role="alert" style="display: none;">
    <p></p>
  </div>
  <div class="entry">
    <div class="entry-item">
      <label for="signInName">
        Email Address
      </label>
      <div class="error itemLevel" aria-hidden="true" role="alert" style="display: none;">
        <p></p>
      </div>
      <input type="email" id="signInName" name="Email Address" title="Please enter a valid Email Address" pattern="^[a-zA-Z0-9.!#$%&amp;amp;&amp;#39;^_\`{}~+-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$" autofocus="" placeholder="Email Address" value="" aria-label="Email Address">
    </div>
      <div class="entry-item">
        <div class="password-label">
          <label for="password">Password</label>
              <a id="forgotPassword" href="/phillipsauthsandbox.onmicrosoft.com/B2C_1A_SignUpOrSignIn/api/CombinedSigninAndSignup/forgotPassword?csrf_token=dkFlR3RJUzBtZHFIYkNwOTE5SitBUW1DRVFwWk04aDFKdGtTdndiR2lIaEZwM2lhaUxJLzhHU1Y0a1dZbHhOcC82ZkhQZUd2bW1KdzlqNWpuZ012RXc9PTsyMDIzLTAyLTA5VDIyOjQ1OjI3LjEyNzY4NDRaOzdnWjVIM1pLTnFOR1l6WHBjTzVHblE9PTt7Ik9yY2hlc3RyYXRpb25TdGVwIjoxfQ==&amp;tx=StateProperties=eyJUSUQiOiI2NmUwM2Y4OS01ZDRmLTQyNWMtOWQ5My02MGFjOTExZTYxZDgifQ&amp;p=B2C_1A_SignUpOrSignIn">Forgot your password?</a>
                        </div>
        <div class="error itemLevel" aria-hidden="true" style="display: none;">
          <p role="alert"></p>
        </div>
        <input type="password" id="password" name="Password" placeholder="Password" aria-label="Password" autocomplete="current-password" aria-required="true">
                    </div>
    <div class="working"></div>


    <div class="buttons">
      <button id="next" type="submit" form="localAccountForm">Sign in</button>
    </div>
  </div>
        <div class="divider">
          <h2>OR</h2>
        </div>
        <div class="create">
          <p>
            Don't have an account?<a id="createAccount" href="/phillipsauthsandbox.onmicrosoft.com/B2C_1A_SignUpOrSignIn/api/CombinedSigninAndSignup/unified?local=signup&amp;csrf_token=dkFlR3RJUzBtZHFIYkNwOTE5SitBUW1DRVFwWk04aDFKdGtTdndiR2lIaEZwM2lhaUxJLzhHU1Y0a1dZbHhOcC82ZkhQZUd2bW1KdzlqNWpuZ012RXc9PTsyMDIzLTAyLTA5VDIyOjQ1OjI3LjEyNzY4NDRaOzdnWjVIM1pLTnFOR1l6WHBjTzVHblE9PTt7Ik9yY2hlc3RyYXRpb25TdGVwIjoxfQ==&amp;tx=StateProperties=eyJUSUQiOiI2NmUwM2Y4OS01ZDRmLTQyNWMtOWQ5My02MGFjOTExZTYxZDgifQ&amp;p=B2C_1A_SignUpOrSignIn">Sign up now</a>
          </p>
        </div>
</form>
`,
    }}
  ></div>
)

export default Form
